import React from 'react';
import cn from 'classnames';
import localStyles from './FundDetailSplitRow.css';

const FundDetailSplitRow = (props) => {
    if (!props.data) return null;
    const { data, customRender, styles = '' } = props;
    return (
        <div className="element-container">
            {data.map((ele, i) => (
                <div
                    key={ele.label}
                    className={cn('detail-element', { 'add-margin': i < 2 })}
                >
                    <div>{ele.label}</div>
                    <div>
                        {ele.label === 'MORNINGSTAR RATING' &&
                        typeof customRender === 'function'
                            ? customRender(ele.value)
                            : ele.value}
                    </div>
                </div>
            ))}
            <style jsx>{localStyles}</style>
            <style jsx>{styles}</style>
        </div>
    );
};

export default FundDetailSplitRow;
